import { Box, makeStyles } from '@material-ui/core';
import React from 'react';

import { CONSTANTS } from '../../../core/config/constants';

export interface ToolbarProps {
  children?: React.ReactNode;
}

const DataGridToolbar: React.FC<ToolbarProps> = ({ children }) => {
  const classes = useStyles();

  return <Box className={classes.toolbar}>{children}</Box>;
};

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'stretch',
    height: CONSTANTS.TOOLBAR_HEIGHT,
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.background.paper,
    padding: '0 18px',
  },
}));

export default DataGridToolbar;
